import { RequestService } from '../../../../../common/services/RequestService';
import { COLORS_GET } from '../../constants';

export const getColorsRequest = payload => {
  return RequestService.get(COLORS_GET);
};
